import {
  Box,
  Button,
  Checkbox,
  OutlinedInput,
  Pagination,
  PaginationItem,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import React, { lazy, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { saveAs } from "file-saver";
import {
  PrimaryTypography,
  SecondaryTypography,
  StyledOutlinedInput,
  StyledSecondaryTypography,
  StyledTableCell,
  StyledTableRow,
  TypographyDefault,
  StyledSecondaryBookingTypography,
} from "../../Theme";
import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
import { ReactComponent as FilterIcon } from "../../Icons/Filter.svg";
import { ReactComponent as SortIcon } from "../../Icons/Sort.svg";
import { ReactComponent as NumberInputIcon } from "../../Icons/NumberInputIcon.svg";
import { ReactComponent as CheckboxIcon } from "../../Icons/Checkbox.svg";
import { ReactComponent as DeleteIcon } from "../../Icons/DeleteTable.svg";
import { ReactComponent as PreviousIcon } from "../../Icons/Previous.svg";
import { ReactComponent as NextIcon } from "../../Icons/Next.svg";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";
import { ReactComponent as CsvIcon } from "../../Icons/CsvIcon.svg";
import { ReactComponent as PdfIcon } from "../../Icons/PdfIcon.svg";
import { ReactComponent as DownloadIcon } from "../../Icons/DownloadIcon.svg";
import { ReactComponent as DisabledDownloadIcon } from "../../Icons/DisableDownload.svg";
import moment from "moment";
import { FaultReportColumn } from "../../Data";
import axiosInstance from "../../Redux/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { getChip } from "../../Utils";
import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";
import { ReactComponent as MoreIcon } from "../../Icons/ThreeDot.svg";
import dayjs from "dayjs";
import CustomDateRangePicker from "../../CommonComponents/CustomDateRange";
import { showToast } from "../../CommonComponents/Toaster";
import { PostLoaderModal } from "../../CommonComponents/modal";

const InvoicesTable = () => {
  const { LanguageData } = useSelector((state) => state.Language);
  const navigate = useNavigate();
  const [initialRender, setInitialRender] = useState(true);
  const { propertyId } = useSelector((state) => state.PropertyDetails);
  const { UserManage } = useSelector((state) => state.Login);
  const [rowsPerPage, setRowsPerPage] = useState("20");
  const [paginationData, setPaginationData] = useState({});
  const [dateSubmit, setdateSubmit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [faultList, setFaultList] = useState([]);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const downloadOpen = Boolean(downloadAnchorEl);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const filterOpen = Boolean(filterAnchorEl);
  const [filterData, setFilterData] = useState([]);
  const [SelectedFilter, setSelectedFilter] = useState([]);
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const sortOpen = Boolean(sortAnchorEl);
  const [SelectedsortData, setSelectedsortData] = useState("");
  const [searchData, setSearchData] = useState("");
  const [showAnchorEl, setshowAnchorEl] = useState(null);
  const showOpen = Boolean(showAnchorEl);
  const [Tableloading, setTableloading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openDateRangePicker, setopenDateRangePicker] = useState(false);
  const [datetimerangedata, setdatetimerangedata] = useState([null, null]);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const MoreOpen = Boolean(moreAnchorEl);
  const [selectedInvoiceData, setSelectedInvoiceData] = useState(null);
  const tabList = ["Invoices", "Recurring"];
  const [selectedTab, setSelectedTab] = useState("Invoices");
  const [postLoaderDownload, setPostLoaderDownload] = useState(false);

  const getAllFaultReport = async () => {
    setTableloading(true);
    setFaultList([]);
    const data = SelectedFilter.join(",");

    await axiosInstance
      .get(
        `${
          process.env.REACT_APP_API_URL
        }invoice/${propertyId}?page=${currentPage}&record_count=${rowsPerPage}&status_id=${data}&status=${SelectedsortData}&search=${searchData}&recurring=${
          selectedTab == "Invoices" ? null : selectedTab == "Recurring" ? 1 : 0
        }`
      )
      .then((data) => {
        console.log(data);
        setFaultList(data?.data?.data?.invoices);
        setPaginationData(data?.data?.data?.pagination_details);
        setTableloading(false);
      })
      .catch((err) => {
        console.log(err);
        console.log(err?.response?.data?.error);
        if (err?.response?.data?.error == "No data found") {
          setFaultList([]);
        }
        setTableloading(false);
      });
  };

  const getAllFault = async () => {
    setTableloading(true);
    setFaultList([]);
    const data = SelectedFilter.join(",");

    await axiosInstance
      .get(
        `${
          process.env.REACT_APP_API_URL
        }invoice/${propertyId}/recurring-overview?page=${currentPage}&record_count=${rowsPerPage}&status_id=${data}&status=${SelectedsortData}&search=${searchData}&recurring=${
          selectedTab == "Invoices" ? null : selectedTab == "Recurring" ? 1 : 0
        }`
      )
      .then((data) => {
        console.log(data);
        setFaultList(data?.data?.data?.invoices);
        setPaginationData(data?.data?.data?.pagination_details);
        setTableloading(false);
      })
      .catch((err) => {
        console.log(err);
        console.log(err?.response?.data?.error);
        if (err?.response?.data?.error == "No data found") {
          setFaultList([]);
        }
        setTableloading(false);
      });
  };

  useEffect(() => {
    if (selectedTab == "Invoices") {
      getAllFaultReport();
    } else {
      getAllFault();
    }
  }, [currentPage]);

  useEffect(() => {
    if (!initialRender) {
      if (currentPage != 1) {
        setCurrentPage(1);
      } else {
        if (selectedTab == "Invoices") {
          getAllFaultReport();
        } else {
          getAllFault();
        }
      }
    } else {
      setInitialRender(false);
    }
  }, [rowsPerPage, SelectedFilter, SelectedsortData, searchData, selectedTab]);

  const getAllFilteredData = async (ids) => {
    const data = ids.join(",");

    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}fault_report/property/${propertyId}?page=${currentPage}&record_count=${rowsPerPage}&status_id=${data}`
      );
      setFaultList(response?.data?.data?.fault_report);
      setPaginationData(response?.data?.data?.pagination_details);
    } catch (error) {
      console.log(error);
    }
  };
  const getAllSortData = async (data) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}fault_report/property/${propertyId}?sort=${data}`
      );
      setFaultList(response?.data?.data?.fault_report);
      setPaginationData(response?.data?.data?.pagination_details);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = async (data) => {
    // setSearchData(data)
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}fault_report/property/${propertyId}?search=${data}`
      );
      setFaultList(response?.data?.data?.fault_report);
      setPaginationData(response?.data?.data?.pagination_details);
      // setRowsPerPage(response?.data?.data?.pagination_details?.per_page)
    } catch (error) {
      console.log(error);
    }
  };

  const getFilterDD = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}getDropDownDatas?type=fault_report_status`
      );
      setFilterData(response?.data?.data?.drop_down);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getFilterDD();
  }, []);

  const handleNavigate = (id) => {
    navigate(`reviewFaultReport/${id} `);
  };

  const handleSelectedFilter = (e, id) => {
    setCurrentPage("1");
    const Data = SelectedFilter?.find((itm) => itm == id);
    if (Data) {
      const Data = SelectedFilter?.filter((itm) => itm !== id);
      setSelectedFilter(Data);
    } else {
      setSelectedFilter((itm) => [...itm, id]);
    }
  };

  const DownloadReport = async (type) => {
    const data = SelectedFilter.join(",");
    try {
      setLoading(true);
      setDownloadAnchorEl(false);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}fault_report/property/${propertyId}/download?download_type=${type}&page=${currentPage}&record_count=${rowsPerPage}&status_id=${data}&sort=${SelectedsortData}&search=${searchData}`,
        { responseType: "blob" }
      );
      saveAs(response.data, `Fault_report.${type}`);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const DownloadInvoice = async (type) => {
    try {
      setPostLoaderDownload(true); // start loader
      setMoreAnchorEl(null);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}invoice/${selectedInvoiceData?.id}/property/${propertyId}/download`,
        { responseType: "blob" }
      );

      saveAs(response.data, `Invoice.${type}`);
    } catch (error) {
      console.log(error);
    } finally {
      setPostLoaderDownload(false); // stop loader
    }
  };

  const RecurringCancel = async (type) => {
    try {
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_URL
        }invoice/${propertyId}/recurring-cancel?list_id=${
          selectedInvoiceData?.invoice_id
            ? selectedInvoiceData.invoice_id
            : selectedInvoiceData.group_id
        }&type=${selectedInvoiceData.type}`
      );
      console.log(response);
      setMoreAnchorEl(null);
      getAllFault();
      showToast(response?.data?.message, "success");
    } catch (error) {
      console.log(error);
    }
  };

  console.log(selectedInvoiceData);
  return (
    <>
      {postLoaderDownload && <PostLoaderModal />}

      {openDateRangePicker && (
        <CustomDateRangePicker
          openDateRangePicker={openDateRangePicker}
          setopenDateRangePicker={setopenDateRangePicker}
          datetimerangedata={datetimerangedata}
          setdatetimerangedata={setdatetimerangedata}
          setdateSubmit={setdateSubmit}
        />
      )}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box>
          <PrimaryTypography>Invoices</PrimaryTypography>
          <StyledSecondaryTypography>
            A table of all the invoices submitted on the LOBY system.
          </StyledSecondaryTypography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          {/* <Button
            onClick={(e) => setDownloadAnchorEl(e.currentTarget)}
            sx={{
              fontWeight: "600",
              width: "fit-content",
              color: "#0E5E84",
              backgroundColor: "#E7EFF3",
              padding: "10px 16px 10px 16px",
              "&:hover": {
                backgroundColor: "#CFDFE6",
              },
              "&.Mui-disabled": {
                backgroundColor: "#F9FAFB",
                color: "#D2D6DB",
              },
            }}
            disabled={faultList.length === 0 || loading}
          >
            {loading ? (
              <Box sx={{ width: "40px", marginTop: "5px" }}>
                <CircularProgress size={15} />
              </Box>
            ) : (
              <>
                {faultList.length > 0 ? (
                  <DownloadIcon
                    style={{ marginRight: "8px", padding: "3px" }}
                  />
                ) : (
                  <DisabledDownloadIcon
                    style={{ marginRight: "8px", padding: "3px" }}
                  />
                )}
              </>
            )}
            {LanguageData?.home_download_report || "Download Report"}
          </Button> */}
          <Button
            sx={{
              height: "40px",
              padding: "10px 16px",
              borderRadius: "8px",
              backgroundColor: "#0E5E84",
              color: "#FFF",
              fontSize: "14px",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#0E4965",
              },
            }}
            onClick={() => navigate("create-invoice")}
          >
            Create
          </Button>
        </Box>

        <Menu
          sx={{ m: 0.5 }}
          open={downloadOpen}
          anchorEl={downloadAnchorEl}
          onClose={() => setDownloadAnchorEl(null)}
        >
          <MenuItem>
            <TypographyDefault
              onClick={() => DownloadReport("csv")}
              py={0.5}
              sx={{
                fontWeight: "500 !important",
                color: "#1F2A37 !important",
                display: "flex",
              }}
            >
              <CsvIcon width={40} />
              {LanguageData?.Download_csv || "Download as CSV file"}
            </TypographyDefault>
          </MenuItem>
          <MenuItem>
            <TypographyDefault
              onClick={() => DownloadReport("pdf")}
              py={0.5}
              sx={{
                fontWeight: "500 !important",
                color: "#1F2A37 !important",
                display: "flex",
              }}
            >
              <PdfIcon width={40} />
              {LanguageData?.Download_pdf || "Download as PDF file"}
            </TypographyDefault>
          </MenuItem>
        </Menu>
      </Box>

      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          p: 3,
          mt: 4,
          borderRadius: "8px 8px 0px 0px",
          overflowX: "scroll",
          "::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "40px",
            minWidth: "580px",
          }}
        >
          <Box
            sx={{
              border: "1px solid #D2D6DB",
              display: "flex",
              borderRadius: "10px",
            }}
          >
            {tabList.map((value, index) => (
              <Box
                key={index}
                onClick={() => setSelectedTab(value)}
                sx={{
                  borderRadius:
                    index == 0
                      ? "8px 0 0 8px"
                      : index == value?.length - 1
                      ? " 0 8px 8px 0 "
                      : "",
                  borderLeft: "1px solid #E5E7EB",
                  borderRight: "1px solid #E5E7EB",
                  backgroundColor: value == selectedTab ? "#F3F4F6" : "initial",
                  padding: "10px 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": { cursor: "pointer" },
                }}
              >
                <Typography
                  sx={{
                    color: value === selectedTab ? "#111927" : "#4D5761",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                  textAlign={"center"}
                >
                  {value}
                </Typography>
              </Box>
            ))}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <StyledOutlinedInput
              placeholder="Search"
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
              startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
            />
            {/* <Box
            onClick={() => {
              setopenDateRangePicker(true);
            }}
            sx={{
              minWidth: "237px",
              minHeight: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #D2D6DB",
              borderRadius: "8px",
              px: 2,
              ml: 2,
              "&:hover": {
                cursor: "pointer",
                backgroundColor: "#F9FAFB",
              },
            }}
          >
            <DatePickerIcon style={{ marginRight: "10px" }} />
            <StyledSecondaryBookingTypography>
              {Boolean(datetimerangedata[0])
                ? moment(datetimerangedata[0]?.$d).format("MMM D YYYY")
                : "MMM DD YYY"}{" "}
              -{" "}
              {Boolean(datetimerangedata[1])
                ? moment(datetimerangedata[1]?.$d).format("MMM D YYYY")
                : "MMM DD YYY"}
            </StyledSecondaryBookingTypography>
          </Box> */}
            <Box
              onClick={(e) => {
                setSortAnchorEl(e.currentTarget);
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #D2D6DB",
                borderRadius: "6px",
                padding: "10px 16px",
                "&:hover": { cursor: "pointer", backgroundColor: "#F9FAFB" },
              }}
            >
              <SortIcon style={{ marginRight: "10px" }} />
              <SecondaryTypography>
                {LanguageData?.sort_filter || "Sort"}{" "}
              </SecondaryTypography>
            </Box>
            {/* <Box
              onClick={(e) => {
                setFilterAnchorEl(e.currentTarget);
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #D2D6DB",
                borderRadius: "6px",
                padding: "10px 16px",
                "&:hover": { cursor: "pointer", backgroundColor: "#F9FAFB" },
              }}
            >
              <FilterIcon style={{ marginRight: "10px" }} />
              <SecondaryTypography>
                {" "}
                {LanguageData?.filter_common || "Filters"}{" "}
              </SecondaryTypography>
            </Box> */}
          </Box>
        </Box>
      </Box>
      <Box
        sx={{ border: "1px solid #E5E7EB", borderRadius: "0px 0px 8px 8px" }}
      >
        {faultList?.length > 0 ? (
          <>
            {selectedTab == "Invoices" && (
              <TableContainer>
                <Table>
                  <TableHead>
                    <StyledTableRow>
                      {/* <StyledTableCell>
                      <Checkbox size="small" icon={<CheckboxIcon />} />
                    </StyledTableCell> */}
                      <StyledTableCell>Invoice No</StyledTableCell>
                      <StyledTableCell>Invoice Type</StyledTableCell>
                      <StyledTableCell>Resident</StyledTableCell>
                      <StyledTableCell>Unit</StyledTableCell>
                      <StyledTableCell>Status</StyledTableCell>
                      <StyledTableCell>Date Issued</StyledTableCell>
                      <StyledTableCell>Due Date</StyledTableCell>
                      <StyledTableCell>Paid On</StyledTableCell>
                      <StyledTableCell>Amount</StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {faultList?.map((value, index) => {
                      return (
                        <StyledTableRow sx={{ height: "70px" }} key={index}>
                          {/* <StyledTableCell>
                          <Checkbox size="small" icon={<CheckboxIcon />} />
                        </StyledTableCell> */}
                          <StyledTableCell>
                            {value?.invoice_no || "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.invoice_type
                              ? value?.invoice_type == 1
                                ? "Single Resident"
                                : "Multiple Residents"
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.resident_name || "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.building_unit_name || "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {getChip(value?.status)}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.invoice_date !== null
                              ? dayjs(value?.invoice_date).format("DD MMM YYYY")
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.due_date !== null
                              ? dayjs(value?.due_date).format("DD MMM YYYY")
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.paid_at !== null
                              ? dayjs(value?.paid_at).format("DD MMM YYYY")
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            S$ {value?.total_amount || "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            <MoreIcon
                              onClick={(e) => {
                                setMoreAnchorEl(e.currentTarget);
                                setSelectedInvoiceData(value);
                              }}
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {selectedTab == "Recurring" && (
              <TableContainer>
                <Table>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>
                        <Checkbox size="small" icon={<CheckboxIcon />} />
                      </StyledTableCell>

                      <StyledTableCell>Bill Name</StyledTableCell>

                      <StyledTableCell>Amount</StyledTableCell>
                      <StyledTableCell>Frequency</StyledTableCell>
                      <StyledTableCell>Type</StyledTableCell>
                      <StyledTableCell>Start Date</StyledTableCell>
                      <StyledTableCell>Next Due Date</StyledTableCell>
                      <StyledTableCell>End Date</StyledTableCell>
                      <StyledTableCell>Status</StyledTableCell>

                      <StyledTableCell></StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {faultList?.map((value, index) => {
                      return (
                        <StyledTableRow sx={{ height: "70px" }} key={index}>
                          <StyledTableCell>
                            <Checkbox size="small" icon={<CheckboxIcon />} />
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.bill_name || "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            S$ {value?.amount || "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.frequency || "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.type
                              ? value.type.charAt(0).toUpperCase() +
                                value.type.slice(1)
                              : "-"}
                          </StyledTableCell>
                          {/* <StyledTableCell>{value?.invoice_type ? value?.invoice_type == 1 ? "Single Resident" : "Multiple Residents" : "-"}</StyledTableCell> */}
                          {/* <StyledTableCell>{value?.resident_name || '-'}</StyledTableCell> */}
                          {/* <StyledTableCell>{value?.building_unit_name || '-'}</StyledTableCell> */}

                          <StyledTableCell>
                            {value?.invoice_date !== null
                              ? dayjs(value?.invoice_date).format("DD MMM YYYY")
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.next_due_date !== null
                              ? dayjs(value?.next_due_date).format(
                                  "DD MMM YYYY"
                                )
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {value?.end_date !== null
                              ? dayjs(value?.end_date).format("DD MMM YYYY")
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {getChip(value?.status)}
                          </StyledTableCell>
                          {/* <StyledTableCell>{value?.paid_at !== null ? dayjs(value?.paid_at).format("DD MMM YYYY") : '-'}</StyledTableCell> */}

                          <StyledTableCell>
                            <MoreIcon
                              onClick={(e) => {
                                setMoreAnchorEl(e.currentTarget);
                                setSelectedInvoiceData(value);
                              }}
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                borderTopStyle: "none !important",
                // border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 2.5,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{ color: "#4D5761", fontSize: "14px", fontWeight: 500 }}
                >
                  {LanguageData?.Common_Show || "Show :"}
                </Typography>
                {/* <OutlinedInput inputProps={{ min: 5, max: 30, step: 5 }} value={rowsPerPage} onChange={(e) => { setRowsPerPage(e.target.value); setCurrentPage('1') }} type='number' sx={{ height: '40px', width: '100px', ml: 2, borderRadius: '8px' }} /> */}
                <Box
                  onClick={(e) => setshowAnchorEl(e.currentTarget)}
                  sx={{
                    width: "95px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px",
                    ml: 2,
                    "&:hover": { cursor: "pointer" },
                  }}
                >
                  <Typography
                    sx={{ fontSize: "15px" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {rowsPerPage} rows{" "}
                    <NumberInputIcon style={{ paddingLeft: "5px" }} />
                  </Typography>
                </Box>
              </Box>
              <Pagination
                size="medium"
                page={currentPage}
                count={paginationData?.last_page}
                onChange={(e, value) => setCurrentPage(value)}
                shape="rounded"
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: PreviousIcon, next: NextIcon }}
                    {...item}
                  />
                )}
              />
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "50vh",
              justifyContent: "center",
            }}
          >
            {Tableloading ? (
              <CircularProgress />
            ) : (
              <>
                <ExclamatoryIcon />
                <Typography
                  sx={{
                    color: "#9DA4AE",
                    fontSize: "16px",
                    fontWeight: 600,
                    my: 2,
                  }}
                >
                  {LanguageData?.No_Faul || "No Data Found"}
                </Typography>
                <StyledSecondaryTypography>
                  {LanguageData?.No_Fault_Haede ||
                    "There are no active or past invoices at the moment."}{" "}
                </StyledSecondaryTypography>
                <StyledSecondaryTypography>
                  {LanguageData?.No_Fault_Haeder_su ||
                    " Residents are able to submit invoices via the LOBY mobile app. Once submitted, you will see it here for processing."}
                </StyledSecondaryTypography>
              </>
            )}
          </Box>
        )}
      </Box>

      <Menu
        sx={{ m: 0.5 }}
        open={sortOpen}
        anchorEl={sortAnchorEl}
        onClose={() => setSortAnchorEl(null)}
      >
        {selectedTab == "Invoices" && (
          <>
            <MenuItem
              sx={{
                backgroundColor: SelectedsortData == "new" ? "#eff3f5" : "",
              }}
              onClick={() => {
                setSelectedsortData("");
                setSortAnchorEl(null);
              }}
            >
              <Typography>All</Typography>
            </MenuItem>
            <MenuItem
              sx={{
                backgroundColor: SelectedsortData == "old" ? "#eff3f5" : "",
              }}
              onClick={() => {
                setSelectedsortData("0");
                setSortAnchorEl(null);
              }}
            >
              <Typography>Pending</Typography>
            </MenuItem>
            <MenuItem
              sx={{
                backgroundColor: SelectedsortData == "recent" ? "#eff3f5" : "",
              }}
              onClick={() => {
                setSelectedsortData("1");
                setSortAnchorEl(null);
              }}
            >
              <Typography>Completed</Typography>
            </MenuItem>
          </>
        )}

        {selectedTab == "Recurring" && (
          <>
            <MenuItem
              sx={{
                backgroundColor: SelectedsortData == "new" ? "#eff3f5" : "",
              }}
              onClick={() => {
                setSelectedsortData("");
                setSortAnchorEl(null);
              }}
            >
              <Typography>All</Typography>
            </MenuItem>
            <MenuItem
              sx={{
                backgroundColor: SelectedsortData == "old" ? "#eff3f5" : "",
              }}
              onClick={() => {
                setSelectedsortData("Active");
                setSortAnchorEl(null);
              }}
            >
              <Typography>Active</Typography>
            </MenuItem>
            <MenuItem
              sx={{
                backgroundColor: SelectedsortData == "recent" ? "#eff3f5" : "",
              }}
              onClick={() => {
                setSelectedsortData("Completed");
                setSortAnchorEl(null);
              }}
            >
              <Typography>Completed</Typography>
            </MenuItem>
            <MenuItem
              sx={{
                backgroundColor: SelectedsortData == "recent" ? "#eff3f5" : "",
              }}
              onClick={() => {
                setSelectedsortData("Canceled");
                setSortAnchorEl(null);
              }}
            >
              <Typography>Cancelled</Typography>
            </MenuItem>
          </>
        )}
      </Menu>
      <Menu
        sx={{ m: 0.5 }}
        open={filterOpen}
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
      >
        {filterData?.map((itm, index) => (
          <MenuItem
            onClick={(e) => {
              handleSelectedFilter(e, itm?.id);
            }}
          >
            <Checkbox
              sx={{ width: "42px", height: "42px" }}
              value={itm?.id}
              checked={Boolean(SelectedFilter.find((item) => itm?.id == item))}
              icon={<CheckboxIcon />}
            />
            <Typography sx={{ mr: 3 }}>{itm?.name}</Typography>
          </MenuItem>
        ))}

        {/* 
                <MenuItem>
                    <Checkbox icon={<CheckboxIcon />} />
                    <Typography>Investigating</Typography>
                </MenuItem>
                <MenuItem>
                    <Checkbox icon={<CheckboxIcon />} />
                    <Typography>Completed</Typography>
                </MenuItem>
                <MenuItem>
                    <Checkbox icon={<CheckboxIcon />} />
                    <Typography>Cancelled</Typography>
                </MenuItem> */}
      </Menu>

      <Menu
        sx={{ m: 0.5 }}
        open={showOpen}
        anchorEl={showAnchorEl}
        onClose={() => setshowAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setRowsPerPage(10);
            setshowAnchorEl(null);
          }}
        >
          <Typography>10 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(20);
            setshowAnchorEl(null);
          }}
        >
          <Typography>20 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(30);
            setshowAnchorEl(null);
          }}
        >
          <Typography>30 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(40);
            setshowAnchorEl(null);
          }}
        >
          <Typography>40 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(50);
            setshowAnchorEl(null);
          }}
        >
          <Typography>50 rows</Typography>
        </MenuItem>
      </Menu>

      <Menu
        sx={{
          m: 0.5,
          "& .MuiPaper-root.MuiPopover-paper.MuiMenu-paper": {
            marginTop: "-30px !important",
          },
        }}
        open={MoreOpen}
        anchorEl={moreAnchorEl}
        onClose={() => setMoreAnchorEl(null)}
      >
        {/* {selectedTab == 'Recurring' && (
          <MenuItem onClick={() => navigate(`edit-invoice/${selectedInvoiceData?.id}`)}>
          <Typography>Edit</Typography>
        </MenuItem>
        )} */}

        {/* <MenuItem>
          <Typography>Change Status</Typography>
        </MenuItem> */}
        {selectedTab == "Recurring" && (
          <MenuItem onClick={() => RecurringCancel()}>
            <Typography>Cancel Recurring</Typography>
          </MenuItem>
        )}
        {selectedTab == "Invoices" && (
          <MenuItem onClick={() => DownloadInvoice("pdf")}>
            <Typography>Download Invoice</Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default InvoicesTable;
